import { Radio } from 'components';
import { get } from 'lodash';
import React, { useState } from 'react';
import './termsAndMessaging.less';

export default function TermsAndConditions({
  hasAcceptedTerms,
  setField,
  fieldsErrors,
}) {
  const [acceptedTerms, setAcceptedTerms] = useState(hasAcceptedTerms);
  const handleAccept = () => {
    setAcceptedTerms(!acceptedTerms);
    setField(!acceptedTerms);
  };

  return (
    <>
      <h1 className="h2">please accept our terms & conditions</h1>
      <p className="bodycopy2">
        By creating an account, you agree to our{' '}
        <a
          rel="noreferrer"
          target="_blank"
          href="https://nue.life/terms-conditions">
          Terms of Service.
        </a>{' '}
        <br /> For more information about Nue life's privacy practices, see the{' '}
        <a
          rel="noreferrer"
          target="_blank"
          href="https://nue.life/privacy-policy">
          Nue.life Privacy Statement
        </a>
      </p>

      <Radio
        error={fieldsErrors && get(fieldsErrors, 'acceptedTerms')}
        checked={acceptedTerms}
        name="acceptedTerms"
        onChange={handleAccept}
        label={<>I agree to the terms and conditions</>}
        type="checkbox"
      />
    </>
  );
}